import React from 'react';
import { useRecoilValue } from 'recoil';
import { pointerSelector } from '~/components/page/Forms/components/Builder/state/nodesAndEvents';

type Props = {
  pointer: [string, string];
};

const PointerRenderer: React.FCC<Props> = props => {
  const pointerValue = useRecoilValue(pointerSelector(props.pointer));
  return <span>{pointerValue}</span>;
};

export default PointerRenderer;
